/**
 * The poster's size or finish choices, for whoever shows them — the desktop screens
 * (shared.screens.PosterSizeScreen / PosterFinitionScreen) and the mobile sheet
 * (shared.popups.PosterOptionsSheet) : the catalogue's formats, prices and names turned into
 * cards, and the choice applied to the creation. Design handoffs "Taille / Finition" (desktop) and
 * "Éditeur mobile".
 *
 *   new shared.components.PosterSizeOptions(model, { mobile })
 *   kind, title, subtitle
 *   cards()        [{ id, html }] : real buttons, aria-pressed on the current choice
 *   apply(id)      the choice made on the creation
 */
fx.ns("shared.components", class PosterBaseOptions {

    constructor(model, options)
    {
        this.model = model;
        this.mobile = !!(options && options.mobile);
    }

    get creation()
    {
        return this.model.creation;
    }

    price(creationOption)
    {
        let value = creationOption.price_base * fx.get("lang").tax;
        return value.toLocaleString(document.documentElement.lang || "fr", { minimumFractionDigits : 2, maximumFractionDigits : 2 }) + " €";
    }

    /**
     * The size in cm as it is sold : the format's description ("30 x 40 cm"), else its width and
     * height in mm, in the poster's orientation.
     */
    dimensions(format)
    {
        let size;
        let found = /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i.exec(format.description || format.dimensions || "");
        if (found)
            size = { width : parseFloat(found[1].replace(",", ".")), height : parseFloat(found[2].replace(",", ".")) };
        else
            size = { width : (format.width || 400) / 10, height : (format.height || 600) / 10 };

        let short = Math.min(size.width, size.height), long = Math.max(size.width, size.height);
        return this.creation.shape_option == "landscape" ? { width : long, height : short } : { width : short, height : long };
    }

    dimensionsLabel(size)
    {
        let label = (cm) => (Math.round(cm * 10) / 10).toLocaleString(document.documentElement.lang || "fr");
        return label(size.width) + " × " + label(size.height) + " cm";
    }

    static check()
    {
        return '<span class="poCheck" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    }

    static escape(text)
    {
        return String(text == null ? "" : text).replace(/[&<>"]/g, (c) => ({ "&" : "&amp;", "<" : "&lt;", ">" : "&gt;", '"' : "&quot;" }[c]));
    }
});
